import { Paper } from '@mui/material';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import ApiService from '../../functions/apiService';
import { Col, Row } from 'react-bootstrap';
import moment from 'moment';
import { toast } from 'react-toastify';

export function RevertStation(props) {
  const { date, revertData , loadData, backFunction,  shift ,  setRevertStation } = props;
  const mode = localStorage.getItem('mode');

  let handleRevertData = () => {
    if (revertData.overtime_shifts && revertData.overtime_shifts.length > 0) {
      let selectedShift = revertData.overtime_shifts.find((e) => e.Shift_Date == date)

      if(mode === '24'){
        if(shift === 'night'){
          selectedShift = revertData.overtime_shifts.find(
            (e) => e.Shift_Date === date && (e.Shift_Code === 3 || e.Shift_Code > 90)
          );
        }
        else{
          selectedShift = revertData.overtime_shifts.find(
            (e) => e.Shift_Date === date && (e.Shift_Code === 2 || e.Shift_Code > 90)
          );
        }
      }
      else{
        if(mode === 'night'){
          selectedShift = revertData.overtime_shifts.find(
            (e) => 
              e.Shift_Date === date && 
              (e.Shift_Code === 3 || e.Shift_Code > 90)
          );
        }
        else{
          selectedShift = revertData.overtime_shifts.find(
            (e) => 
              e.Shift_Date === date && 
              (e.Shift_Code === 2 || e.Shift_Code > 90)
          );
        }
      }

      const req = {
        "Shift_Date": date,
        "Emp_Code": revertData?.Emp_Code ,
        "Shift_Code" : selectedShift?.Shift_Code ,
        "Shift_Number" : selectedShift?.Shift_Number,
        "Start_Time" : selectedShift?.Shift_Code === 91 ? selectedShift?.Start_Time : '',
        "End_Time" : selectedShift?.Shift_Code === 91 ? selectedShift?.End_Time : '',
      }
      ApiService.post('/revert-user-assignment', req)
        .then((res) => {
          loadData(moment(date).format('DD-MM-YYYY'))
          setRevertStation(false)
        }).catch((err) => {
          if (err && err.status === 400) {
            toast.error(err?.data?.message || 'Bad Request')
          } else {
            toast.error('Something went wrong')
          }
        })
    }
  }


  return (
    <>
      <Paper elevation={0}>
        <>
            <div style={{ color: '#555555' }}>
                Are you sure you want to revert the station details and go back to the original schedule ?
            </div>
            <Row>
                <Col md='auto'>
                <ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={backFunction}>
                    Cancel
                </ButtonTheme>
                </Col>
                <Col md='auto'>
                <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={handleRevertData}>
                    Revert
                </ButtonTheme>
                </Col>
            </Row>
        </>
      </Paper>
    </>
  )
}
